const recallPaymentCustomerTypes = {
    GET_RPC_SUCCESS: "GET_RPC_SUCCESS",
    GET_RPC_ERROR: "GET_RPC_ERROR",
  };
  
  export default recallPaymentCustomerTypes;
  